import { Dialog } from '@shared/components';
import { EditPricesForSelectedItems } from './EditPricesForSelectedItems';
import { DialogTitle } from '@mui/material';
import { usePriceSuggestionTFunction } from '@retail/price-suggestion/i18n';
import { PriceSuggestionPrice, PriceSuggestionPriceItem } from '@retail/price-suggestion/types';
import { useCallback, useMemo, useState } from 'react';

interface Props {
  itemsToEdit: PriceSuggestionPrice[];
  editLocalPriceSuggestions: (updatedItems: PriceSuggestionPriceItem[]) => void;
  onClose: () => void;
}

export function EditPriceSuggestionsDialog({
  itemsToEdit,
  editLocalPriceSuggestions,
  onClose,
}: Props) {
  const t = usePriceSuggestionTFunction();

  const priceSuggestionsToEdit = useMemo(
    () =>
      itemsToEdit.map((item) => {
        return {
          mgItemNumber: item.mgSupplierItem.mgItemNumber,
          primaryText: item.mgSupplierItem.primaryText,
          mgSupplierId: item.mgSupplierItem.mgParticipantAccount.mgSupplierId,
          mgSupplierName: item.mgSupplierItem.mgParticipantAccount.name,
          mgSupplierItemId: item.mgSupplierItem.mgSupplierItemId,
          price: item.price,
          validFrom: new Date(item.validFrom) < new Date() ? new Date() : new Date(item.validFrom),
          validTo: item.validTo ? new Date(item.validTo) : undefined,
        };
      }) as PriceSuggestionPriceItem[],
    [itemsToEdit]
  );

  const [priceSuggestionPriceItems, setPriceSuggestionPriceItems] =
    useState<PriceSuggestionPriceItem[]>(priceSuggestionsToEdit);

  const handleEditPriceSuggestions = useCallback(() => {
    editLocalPriceSuggestions(priceSuggestionPriceItems);
    onClose();
  }, [editLocalPriceSuggestions, onClose, priceSuggestionPriceItems]);

  return (
    <Dialog open onClose={onClose} fullScreen sx={{ p: 6 }}>
      <DialogTitle>{t('priceSuggestion.actions.editPriceSuggestions')}</DialogTitle>
      <EditPricesForSelectedItems
        priceSuggestionPriceItems={priceSuggestionPriceItems}
        setPriceSuggestionPriceItems={setPriceSuggestionPriceItems}
        onClose={onClose}
        handleSubmitPrices={handleEditPriceSuggestions}
      />
    </Dialog>
  );
}
